// @ts-nocheck
import { Trans } from '@lingui/react'

import { PRESCRIPTION_TYPE_PRIVAT } from 'shared/consts/productTemplates'
import {
  EXPERIMENT_VARIATION,
  TOTAAL_KORTING_AB_TEST,
} from 'shared/experiments/consts'
import Price from 'views/components/atoms/Price'
import Experiment from 'views/components/utils/optimizely/Experiment'
import Variant from 'views/components/utils/optimizely/Variant'
import { useLinePercentPromotions } from 'views/enhancers/useLinePercentPromotions'

import ErxPriceLabel from './ErxPriceLabel'
import RxPriceLabel from './RxPriceLabel'

const PriceBox = ({
  product,
  isERx,
  currency,
  evaluatedProductType,
  promotions,
}) => {
  // AfterBilling or "nach Rechnungslegung" only needs to be displayed for
  // private ERx which do not have a PZN or are not on record. In any other case
  // we will display the total price.
  const showAfterBilling =
    isERx &&
    evaluatedProductType === PRESCRIPTION_TYPE_PRIVAT &&
    (product?.pzn?.length <= 0 || !product.isProductOnRecord)

  const { linePercentPromotions } = useLinePercentPromotions()

  const productHasLinePercentPromotion =
    Array.isArray(promotions?.linePercent) &&
    promotions.linePercent.includes(product.offerId)

  const getLinePromotionDiscount = () =>
    linePercentPromotions.length > 0 ? (
      <Experiment name={TOTAAL_KORTING_AB_TEST} preventActivation>
        <Variant name={EXPERIMENT_VARIATION.DEFAULT}>
          {() => (
            <Price
              amount={product.lineDiscountedLineAmount}
              currency={currency}
              dataQa="cart-entry-totalPrice"
            />
          )}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V1}>
          {() => (
            <Price
              amount={product.lineDiscountedLineAmount}
              currency={currency}
              dataQa="cart-entry-totalPrice"
            />
          )}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V2}>
          {() => (
            <Price
              amount={product.itemTotal}
              currency={currency}
              dataQa="cart-entry-totalPrice"
            />
          )}
        </Variant>

        <Variant name={EXPERIMENT_VARIATION.V3}>
          {() => (
            <Price
              amount={product.itemTotal}
              currency={currency}
              dataQa="cart-entry-totalPrice"
            />
          )}
        </Variant>
      </Experiment>
    ) : (
      <Price
        amount={product.lineDiscountedLineAmount}
        currency={currency}
        dataQa="cart-entry-totalPrice"
      />
    )

  const getPrice = () =>
    productHasLinePercentPromotion ? (
      getLinePromotionDiscount()
    ) : (
      <Price
        amount={product.itemTotal}
        currency={currency}
        dataQa="cart-entry-totalPrice"
      />
    )

  const renderPriceLabel = () => {
    switch (true) {
      case isERx:
        return (
          <ErxPriceLabel
            product={product}
            evaluatedPrescriptionType={evaluatedProductType}
          />
        )
      case product.isRx:
        return (
          <RxPriceLabel
            product={product}
            evaluatedPrescriptionType={evaluatedProductType}
          />
        )
      default:
        return (
          <span className="u-font-weight--normal o-ProductListing__PriceBox__label__text">
            <Trans id="general.label.sum" />
          </span>
        )
    }
  }

  return (
    <>
      <div
        className="a-p u-font-weight--bold o-ProductListing__PriceBox__label"
        data-qa-id="cart-entry-totalSumTerm"
      >
        {renderPriceLabel()}
      </div>
      <div className="a-h2 u-no-margin--bottom">
        {showAfterBilling ? (
          <span className="o-ProductListing__itemTotal--afterBilling">
            <Trans id="general.label.afterBilling" />
          </span>
        ) : (
          getPrice()
        )}
      </div>
    </>
  )
}

export default PriceBox
